import {ParameterCategory} from '../Parameters.types'

export function getCategoryTitle(category: ParameterCategory) {
  switch (category) {
    case ParameterCategory.USER_DEFINED:
      return 'User Defined Parameters'
    case ParameterCategory.ACTUAL:
      return 'Actual Parameters'
    case ParameterCategory.ACTUAL_ON_AGENT:
      return 'Actual Parameters on Agent'
    default:
      return ''
  }
}
